import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';
import rstheme from './styles/rstheme.js';
import App from './App';

//JB - Does removing StrictMode prevent onsubmit from triggering twice.
//further research strictmode for side effects

ReactDOM.render(
  <ChakraProvider resetCSS theme={rstheme}>
    <App />
  </ChakraProvider>,
  document.getElementById('root'),
);
/*
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <ChakraProvider resetCSS theme={rstheme}>
    <App />
  </ChakraProvider>,
  );
*/